"use client";

import { Bell, Building2, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { IconButton } from "@/components/ui/icon-button";

type TopbarProps = {
  collapsed: boolean;
  onToggle: () => void;
};

export function Topbar({ collapsed, onToggle }: TopbarProps) {
  const ToggleIcon = collapsed ? PanelLeftOpen : PanelLeftClose;
  const pathname = usePathname();
  const section = pathname === "/" ? "Centro de control" : pathname.split("/").filter(Boolean).at(-1)?.replaceAll("-", " ") ?? "Operación general";

  return (
    <header className="topbar">
      <IconButton label={collapsed ? "Expandir navegación" : "Contraer navegación"} onClick={onToggle}>
        <ToggleIcon aria-hidden="true" />
      </IconButton>
      <div className="topbar-context">
        <span>Centelsa Access</span>
        <strong>{section}</strong>
      </div>

      <div className="topbar-actions">
        <div className="plant-selector" title="Dato visual de referencia">
          <Building2 aria-hidden="true" />
          <span>Planta Yumbo</span>
        </div>
        <IconButton className="notification-button" label="Notificaciones">
          <Bell aria-hidden="true" />
          <span className="notification-dot" />
        </IconButton>
        <Link className="topbar-profile" href="/auth/reauthentication" title="Vista visual de reautenticación">
          <span className="avatar">JD</span>
          <span className="topbar-profile-copy">
            <strong>Julio De La Roche</strong>
            <span>SUPER_ADMIN</span>
          </span>
        </Link>
      </div>
    </header>
  );
}
